{
    "availabilityZones": [],
    "badges": [],
    "gridUnitPixels": 20,
    "heightUnits": 32,
    "labels": [
        {
            "alignment": "center",
            "color": "#e8e9eb",
            "fontSize": 0.5,
            "id": "label-1",
            "label": "DEMO / SANDBOX\nONLY",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "wrapMode": "none",
            "x": 9.5,
            "y": 20.5
        }
    ],
    "lines": [],
    "mapId": "garage",
    "mapName": "Garage",
    "rackSlots": [
        {
            "capacityU": 24,
            "depth": 5,
            "id": "garage-floor-slot-0",
            "purpose": "standard",
            "rotation": 90,
            "slot": 0,
            "type": "standing",
            "width": 7,
            "x": 0.5,
            "y": 14
        },
        {
            "capacityU": 4,
            "depth": 7,
            "eddSlotU": 4,
            "id": "garage-wall-rack",
            "purpose": "uplink",
            "rotation": 90,
            "type": "wall",
            "width": 3,
            "x": 6,
            "y": 25.5
        },
        {
            "capacityU": 42,
            "depth": 5,
            "id": "garage-floor-slot-1",
            "purpose": "standard",
            "rotation": 90,
            "slot": 1,
            "type": "standing",
            "width": 7,
            "x": 6,
            "y": 14
        }
    ],
    "schema": "uptime-facility-map",
    "version": 2,
    "walls": [
        {
            "id": "garage-north",
            "kind": "exterior",
            "x1": 1,
            "x2": 22.5,
            "y1": 1,
            "y2": 1
        },
        {
            "id": "garage-east",
            "kind": "exterior",
            "x1": 22.5,
            "x2": 22.5,
            "y1": 1,
            "y2": 31
        },
        {
            "id": "garage-south-left",
            "kind": "exterior",
            "x1": 1,
            "x2": 22.5,
            "y1": 31,
            "y2": 31
        },
        {
            "id": "garage-west",
            "kind": "exterior",
            "x1": 1,
            "x2": 1,
            "y1": 1,
            "y2": 31
        }
    ],
    "widthUnits": 25,
    "zones": [
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#36c6b1",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 15,
            "id": "garage-ops-console-1",
            "label": "OPS\nCONSOLE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 5.5,
            "wrapMode": "none",
            "x": 16.5,
            "y": 15.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#d9aa2f",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5.5,
            "id": "garage-delivery-zone-1",
            "label": "DELIVERY\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 7.5,
            "wrapMode": "none",
            "x": 1.5,
            "y": 1.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#e95b55",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5.5,
            "id": "garage-sell-zone-1",
            "label": "SELL\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6.5,
            "wrapMode": "none",
            "x": 9.5,
            "y": 1.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#85898f",
            "fillOpacity": 9,
            "fontSize": 0.5,
            "height": 13.5,
            "id": "garage-lordorm-s-notice-board-1",
            "label": "Lordorm's\nnotice-board",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 5.5,
            "wrapMode": "word",
            "x": 16.5,
            "y": 1.5
        }
    ]
}
